import { Button, Modal, Collapse, Tag, Divider } from 'antd'
import { FileTextOutlined, HeartOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import { getData } from '../../resources'

export default function ExpedientesLegacyModal({ id_paciente }) {
    const [open, setOpen] = useState(false)

    const [notas, setNotas] = useState([])

    useEffect(() => {
        getData(`notas/${id_paciente}`).then((data) => {
            console.log('received old notas', data)
            setNotas(data)
        })

    }, [id_paciente])

    const styles = {
        noteCard: {
            marginBottom: 20,
            padding: 24,
            borderRadius: 12,
            border: '1px solid #e1e8ed',
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            background: '#fff',
            transition: 'all 0.3s ease',
        },
        cardHeader: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginBottom: 20,
            paddingBottom: 16,
            borderBottom: '2px solid #f0f0f0',
        },
        title: {
            fontSize: 18,
            fontWeight: 700,
            color: '#1a1a1a',
            margin: 0,
        },
        fieldGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: 16,
            marginBottom: 16,
        },
        fieldBox: {
            padding: 12,
            borderRadius: 8,
            background: '#f8fafb',
            border: '1px solid #e8eef5',
        },
        label: {
            display: 'block',
            marginBottom: 6,
            color: '#595959',
            fontWeight: 600,
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        },
        value: {
            display: 'block',
            color: '#262626',
            fontSize: 14,
            fontWeight: 500,
        },
        section: {
            marginTop: 20,
            borderRadius: 10,
            overflow: 'hidden',
        },
        sectionTitle: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 14,
            fontWeight: 700,
            color: '#1a1a1a',
            margin: 0,
        },
        preformatted: {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            margin: 0,
            padding: 10,
            background: '#f5f5f5',
            borderRadius: 6,
            border: '1px solid #e1e1e1',
            color: '#404040',
            fontSize: 13,
            lineHeight: 1.5,
        },
        evolutionEntry: {
            padding: 16,
            marginBottom: 12,
            borderRadius: 8,
            background: '#fafbfc',
            border: '1px solid #e8f0f8',
        },
        badge: {
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: 6,
            background: '#e6f7ff',
            color: '#1677d2',
            fontSize: 12,
            fontWeight: 600,
        },
    }

    const vitalFields = ['temperatura', 'frecuencia_respiratoria', 'frecuencia_cardiaca', 'presion_arterial', 'saturacion_oxigeno']

    const getEvolutionItems = (nota) => {
        if (!nota.notas_evolucion?.length) return []

        return [
            {
                key: 'notas_evolucion',
                label: <div style={styles.sectionTitle}><FileTextOutlined /> Notas de Evolución ({nota.notas_evolucion.length})</div>,
                children: (
                    <div>
                        {nota.notas_evolucion.map((evolucion, idx) => (
                            <div key={evolucion._id} style={styles.evolutionEntry}>
                                <div style={{ marginBottom: 12 }}>
                                    <span style={styles.badge}>Entrada {idx + 1}</span>
                                    <span style={{ marginLeft: 10, fontSize: 12, color: '#8c8c8c' }}>
                                        {new Date(evolucion.createdAt).toLocaleDateString()}
                                    </span>
                                </div>

                                <div style={styles.fieldGrid}>
                                    {vitalFields.map(field => (
                                        evolucion[field] && (
                                            <div key={field} style={styles.fieldBox}>
                                                <span style={styles.label}>{field.replace(/_/g, ' ')}</span>
                                                <span style={styles.value}>{evolucion[field]}</span>
                                            </div>
                                        )
                                    ))}
                                </div>

                                <div style={styles.fieldGrid}>
                                    {['s', 'o', 'a', 'p'].map(key => (
                                        evolucion[key] && (
                                            <div key={key}>
                                                <span style={styles.label}>{key.toUpperCase()} - {['Subjetivo', 'Objetivo', 'Asesamiento', 'Plan'][['s', 'o', 'a', 'p'].indexOf(key)]}</span>
                                                <pre style={styles.preformatted}>{evolucion[key]}</pre>
                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ),
            }
        ]
    }

    const getHojaItems = (nota) => {
        if (!nota.hojas_enfermeria?.length) return []

        return [
            {
                key: 'hojas_enfermeria',
                label: <div style={styles.sectionTitle}><HeartOutlined /> Hojas de Enfermería ({nota.hojas_enfermeria.length})</div>,
                children: (
                    <div>
                        {nota.hojas_enfermeria.map((hoja, idx) => (
                            <div key={hoja._id} style={styles.evolutionEntry}>
                                <div style={{ marginBottom: 12 }}>
                                    <span style={styles.badge}>Hoja {idx + 1}</span>
                                    <span style={{ marginLeft: 10, fontSize: 12, color: '#8c8c8c' }}>
                                        Peso: <strong>{hoja.peso} kg</strong> | Dosis: <strong>{hoja.dosis}</strong>
                                    </span>
                                </div>

                                {['inicio', 'intermedio', 'termino'].map(fase => (
                                    hoja[fase] && (
                                        <div key={fase} style={{ marginBottom: 12 }}>
                                            <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1a1a', textTransform: 'uppercase', marginBottom: 8 }}>
                                                {fase === 'inicio' ? '🚀 Inicio' : fase === 'intermedio' ? '⏱️ Intermedio' : '✓ Término'}
                                            </div>
                                            <div style={{ ...styles.fieldGrid, marginBottom: 8 }}>
                                                {Object.entries(hoja[fase]).map(([k, v]) => (
                                                    k !== '_id' && v && (
                                                        <div key={k} style={styles.fieldBox}>
                                                            <span style={styles.label}>{k.replace(/_/g, ' ')}</span>
                                                            <span style={styles.value}>{String(v).slice(0, 50)}</span>
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        </div>
                                    )
                                ))}

                                {hoja.observaciones && (
                                    <div>
                                        <span style={styles.label}>Observaciones</span>
                                        <pre style={styles.preformatted}>{hoja.observaciones}</pre>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ),
            }
        ]
    }

    return (
        <>
            <Button onClick={() => setOpen(true)}  >
                📋 Datos previos del paciente
            </Button>

            <Modal
                title="📋 Datos previos del paciente"
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                width={1000}
                bodyStyle={{ padding: 24, background: '#f5f7fa' }}
                centered
            >
                {!notas || notas.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: 40, color: '#8c8c8c' }}>
                        <p style={{ fontSize: 16 }}>No se encontraron notas previas.</p>
                    </div>
                ) : (
                    notas.map((nota) => (
                        <div key={nota._id || `nota-${Math.random().toString(36).substr(2, 9)}`} style={styles.noteCard}>
                            <div style={styles.cardHeader}>
                                <div>
                                    <h3 style={styles.title}>Nota del {new Date(nota.createdAt).toLocaleDateString()}</h3>
                                </div>
                            </div>

                            {nota.diagnostico && (
                                <div style={{ marginBottom: 16 }}>
                                    <Tag color="blue" style={{ fontSize: 12, padding: '4px 12px' }}>
                                        {nota.diagnostico}
                                    </Tag>
                                </div>
                            )}

                            <div style={styles.fieldGrid}>
                                <div style={styles.fieldBox}>
                                    <span style={styles.label}>Edad</span>
                                    <span style={styles.value}>{nota.edad} años</span>
                                </div>
                                <div style={styles.fieldBox}>
                                    <span style={styles.label}>Talla</span>
                                    <span style={styles.value}>{nota.talla} cm</span>
                                </div>
                                <div style={styles.fieldBox}>
                                    <span style={styles.label}>Peso</span>
                                    <span style={styles.value}>{nota.peso} kg</span>
                                </div>
                                <div style={styles.fieldBox}>
                                    <span style={styles.label}>IMC</span>
                                    <span style={styles.value}>{nota.imc}</span>
                                </div>
                                <div style={styles.fieldBox}>
                                    <span style={styles.label}>Presión arterial</span>
                                    <span style={styles.value}>{nota.presion_arterial}</span>
                                </div>
                                <div style={styles.fieldBox}>
                                    <span style={styles.label}>Recetas</span>
                                    <span style={styles.value}>{nota.recetas?.length || 0} receta(s)</span>
                                </div>
                            </div>

                            {(nota.notas_evolucion?.length > 0 || nota.hojas_enfermeria?.length > 0) && (
                                <>
                                    <Divider style={{ margin: '20px 0' }} />
                                    <Collapse
                                        items={[
                                            ...getEvolutionItems(nota),
                                            ...getHojaItems(nota),
                                        ]}
                                        accordion
                                        defaultActiveKey={[]}
                                    />
                                </>
                            )}
                        </div>
                    ))
                )}
            </Modal>

        </>
    )
}
